import { atom } from "jotai";
import { BackgroundJob } from "@/model";

export const backgroundJobsAtom = atom<BackgroundJob[]>([]);
